import React, { useEffect, useState } from 'react';
import { createTheme, Stack, ThemeProvider } from '@mui/material';
import PaginationMui from '@mui/material/Pagination';

const Pagination = ({ current, total, onPageChange }) => {
  const [page, setPage] = useState(current);

  useEffect(() => {
    setPage(current);
  }, [current]);

  const handlePageChange = (event, value) => {
    setPage(value);
    onPageChange(value);
  };

  return (
    <Stack spacing={2}>
      <PaginationMui
        count={total}
        page={page}
        onChange={handlePageChange}
        variant='outlined'
        shape='rounded'
        color='secondary'
      />
    </Stack>
  );
};

export default Pagination;
